<!--
 Copyright 2022 by domX Private Company

 All rights reserved,
 also regarding any disposal, exploitation, reproduction,
 editing, distribution, as well as in the event of
 applications for industrial property rights.

 This software contains proprietary and confidential
 information of domX Private Company.
 The disclosure of confidential information without
 express authorization is prohibited.

 This software may include Open Source Software.
 As far as Open Source Software is included,
 your rights for the respective Open Source Software
 components are governed by the applicable
 Open Source Software licenses.
-->

<template class="fill-height">    
  <v-card
      flat
      class="secondary fill-height pa-12"
      height="25%">
    <v-form
      v-if="currInstallation"
      ref="form"
      lazy-validation
    >
      <v-subheader class="display-1 grayBold--text">
        {{$t("edit_installation")}}
      </v-subheader>
      <v-list class="secondary card-content" max-height="80vh" max-width="1000px">
        <v-list-item>
          <v-list-item-content class="grayBold--text">
            <v-list-item-title class="subtitle-2 grayBold--text">

            </v-list-item-title>
            <v-flex xs12 sm12 md12 v-if="descriptionIsEnabled">
                <v-textarea
                  light
                  v-model="installationModel.description"
                  :label="$t('description')"
                  auto-grow
                  rows="1"
                  :counter="80"
                  :rules="descriptionRule"
                ></v-textarea>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field class="mr-5" min="1" type="number" required :rules="tagRule" light v-model="installationModel.tag" :label="$t('tag')" v-on:keypress="isNumber"/>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-autocomplete
                  light
                  class="grayBold--text"
                  v-model="installationModel.client"
                  :items="clientsCombo"
                  item-text="name"
                  :label="$t('tenant')"
                  return-object
                  required 
                  :rules="clientRule"
                >
                <template v-slot:item="{ item }">
                  <v-icon class="mr-2"> {{ item.is_business ? 'mdi-domain' : 'mdi-account' }} </v-icon>
                  {{item.name}}
                </template>
                <template v-slot:no-data>
                          <div class="px-4">{{ $t('comboNoData') }}</div>
                        </template>
              </v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-layout align-center>
                <vuetify-google-autocomplete
                  light
                  v-model="installationModel.address"
                  ref="google_address"
                  :label="$t('address')"
                  placeholder=" "
                  id="map"
                  classname="form-control"
                  v-on:placechanged="getAddressData"
                  country="gr"
                  types=""
                  :rules="addressRule"
                >
                </vuetify-google-autocomplete>
                  <v-btn class="mr-5" @click="openAddressModal" :ripple="false" icon color="grayBold">
                <v-icon>mdi-map-marker-outline</v-icon>
              </v-btn>
              </v-layout>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field light required :rules="areaRule" v-model="installationModel.area" :label="$t('area')" />
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field class="mr-5" light v-model="installationModel.zip_code" :rules="zipCodeRule" :label="$t('zip_code')" />
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field min="-9" max="20" type="number" light v-model="installationModel.floor" :label="$t('floor')" v-on:keypress="isNumber"/>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-checkbox
                  light
                  dense
                  v-model="installationModel.is_premium"
                  label="Premium"
                ></v-checkbox>
              </v-flex>
              <v-flex xs12 sm12 md12>
                  <v-textarea
                    light
                    v-model="installationModel.notes"
                    :label="$t('notes')"
                    auto-grow
                    append-icon="mdi-text-box-edit-outline"
                    rows="1"
                    :counter="1000"
                    :rules="notesRule"
                  ></v-textarea>
              </v-flex>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            depressed
            right
            light
            color="grayBold--text secondary"
            @click="hideModal()"
          >
            {{ $t("cancel") }} 
          </v-btn>
          <v-btn
            color="primary"
            depressed
            right
            large
            class="modal-update"
            @click="doUpdateInstallation"><v-icon left>mdi-pencil</v-icon>{{ $t("save") }}
          </v-btn>
        </v-card-actions>
      </v-form>
      </v-card>
</template>

<script lang="ts">
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { commonModule, installationsModule, companyModule } from '@/store/modules/store-accessor'
import { setGoogleMapsInfoToModel } from "@/helpers/data";


@Component
export default class EditInstallationModal extends Vue {
  @Prop()
  payload!: any;

  get currInstallation () {
    return installationsModule.currentInstallation;
  }
 
  installationModel = {
   tag: this.currInstallation.info.tag_id.split('_').pop(),
   client: {name: this.currInstallation.info.client_firstname + " " + this.currInstallation.info.client_lastname, id: this.currInstallation.info.user_id},
   owner: {name: this.currInstallation.info.owner_firstname + " " + this.currInstallation.info.owner_lastname, id: this.currInstallation.info.owner_id},
   address: this.currInstallation.info.address || '',
   area: this.currInstallation.info.area,
   zip_code: this.currInstallation.info.zip_code || '',
   floor: this.currInstallation.info.floor || '',
   is_premium: this.currInstallation.info.is_premium,
   notes: this.currInstallation.info.notes || '',
   latitude: this.currInstallation.info.latitude,
   longitude: this.currInstallation.info.longitude,
   installation_item_id: this.currInstallation.items[0]?.id || null,
   id: this.currInstallation.info.id,
   view: this.payload.view,
   description: this.currInstallation.info.description || '',
  }

  google_address:any;

  evt:any;

  tagRule= [
    (val: any) => !!val || this.$i18n.t("tag_required"),
  ]
  clientRule= [
  (val: any) => ((!!val || val == '') && val.name.length > 0) || this.$i18n.t("tenant_required"),
  ]

  areaRule= [
    (val: any) => !!val || this.$i18n.t("area_required"),
    (val: any) => val.length <= 30 || this.$i18n.t("form_area_length_rule"),
  ]

  addressRule= [
    (val: any) => val.length <= 100 || this.$i18n.t("form_address_length_rule"),
  ]

  zipCodeRule= [
    (val: any) => val.length <= 15 || this.$i18n.t("form_zipCode_length_rule"),
  ]
  notesRule= [
    (val: any) => {
      if(val != null) return val.length <= 1000 || this.$i18n.t("notesLengthRule");
      else return true;
    },
  ]

  descriptionRule = [
    (val: any) => {
      if(val != null) return val.length <= 80 || this.$i18n.t("installationDescriptionLengthRule");
      else return true;
    },
  ]

  get clientsCombo () {
    return commonModule.clientsCombo.map((item: any) => {
      let client_arr = item.is_business
      ? [`${item.entity_name} (${item.name})`]
      : [`${item.name}`]
      return {...item, name: client_arr.filter(Boolean).join(' | ') }
    });
  }

  async hideModal () {
    commonModule.hideModal();
    installationsModule.clearNewInstallationCoordinates();
  }

  doUpdateInstallation () {
    if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
      installationsModule.editInstallation(this.installationModel);
      this.hideModal();  
    }
  }

  async mounted() {
    commonModule.initSnackbar({});
    await commonModule.getClientsCombo();
    await companyModule.getCompanyInfo();
  }

  getAddressData(addressData:any) {
        this.google_address = addressData;
        this.installationModel.area = addressData.locality;
        this.installationModel.zip_code = addressData.postal_code ? addressData.postal_code.replace(/\s/g, "") : '';
        this.installationModel.latitude = addressData.latitude;
        this.installationModel.longitude = addressData.longitude;
  }

  isNumber(evt:any) {
      evt = evt || window.event;
      let charCode = evt.which || evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
      return false;
  }

  get descriptionIsEnabled() {
    return (companyModule.company?.preferences as any)?.installation_description;
  }
  get installationCooridnates() {
    return installationsModule.newInstallationCoordinates;
  }

  @Watch('installationCooridnates')
  updateCoordinates() {
    if(installationsModule.newInstallationCoordinates.length == 2) {
      setGoogleMapsInfoToModel(this.installationModel, installationsModule.newInstallationCoordinates[0], installationsModule.newInstallationCoordinates[1]);
    }
  }

  async openAddressModal() {
    const coordinates = { latitude: this.installationModel.latitude, longitude: this.installationModel.longitude };
    commonModule.showSecondModal({ name: 'add-installation-address-modal', payload: { coordinates: coordinates } });
  }

};
</script>
<style scoped lang="scss">
.card-content {
  overflow: auto;
}
</style>
